"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.immutableDeepMerge = immutableDeepMerge;

var _immutable = require("immutable");

function immutableDeepMerge() {
  var _fromJS;

  return (_fromJS = (0, _immutable.fromJS)({})).mergeDeep.apply(_fromJS, arguments).toJS();
}
//# sourceMappingURL=immutableDeepMerge.js.map